import React, { useState, useEffect, useRef } from "react";


const sections = ['intro', 'skill-section', 'tech-journey-section', 'contact-section'];

function PortfolioHeader(props) {


    const sectionRefs = useRef([]);
    const [activeSection, setActiveSection] = useState(sections[0]);
    const [headerHasBorder, setHeaderHasBorder] = useState(false);

    const section_headings = props.section_headings;
    const { skills,contact, contact_form, journey, intro } = section_headings;


    const scrollSection = (compId) => {

        const targetSection = document.getElementById(compId);

        if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth' });
        }
    }

    useEffect(() => {

        sections.forEach(id => {
            const el = document.getElementById(id);
            if (el) sectionRefs.current[id] = el;
        });

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {

                    let sectionId = entry.target.id;

                    if (entry.isIntersecting) {
                        setActiveSection(sectionId);
                    }

                    if(sectionId === "intro"){
                        setHeaderHasBorder(!entry.isIntersecting);
                    }
                });
            },
            {
                threshold: 0.6, // section becomes active when 60% in view
            }
        );

        // Observe all relevant sections
        Object.values(sectionRefs.current).forEach(el => observer.observe(el));

        return () => {
            Object.values(sectionRefs.current).forEach(el => observer.unobserve(el));
        };
    }, []);

    return (
        <>
            <nav className={`header ${headerHasBorder ? "head-box-shadow" : ""}`}>

                <div className="top">


                    <button
                        className={`nav-button ${activeSection === 'intro' ? 'active' : ''}`}
                        onClick={() => scrollSection("intro")}>{intro}
                    </button>



                    <button
                        className={`nav-button ${activeSection === 'skill-section' ? 'active' : ''}`}
                        onClick={() => scrollSection("skill-section")}
                    >
                        {skills}
                    </button>



                    <button
                        className={`nav-button ${activeSection === 'tech-journey-section' ? 'active' : ''}`}
                        onClick={() => scrollSection("tech-journey-section")}
                    >
                        {journey}
                    </button>


                    <button
                        className={`nav-button ${activeSection === 'contact-section' ? 'active' : ''}`}
                        onClick={() => scrollSection("contact-section")}
                    >
                        {contact}
                    </button>


                </div>

            </nav>

        </>
    )
}

export default PortfolioHeader;